import { isValidURL } from '@/globals';

import BaseEvaluator from './BaseEvaluator';

export default class URLWithMacrosEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'url';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else {
      this.isValid = isValidURL(this.value);
    }
    return this.isValid;
  }
}
